(function () {
  "use strict";

  var root = document.querySelector("[data-water-hardness-mockup-root]");
  if (!root) return;

  var currentScript = document.currentScript;
  var dataUrl = currentScript
    ? currentScript.src.replace(/hard-water-map-mockup\.js(\?.*)?$/, "hard-water-map-mockup-data.json")
    : "/assets/hard-water-map-mockup-data.json";
  var publicUrl = currentScript
    ? currentScript.src.replace(/hard-water-map-mockup\.js(\?.*)?$/, "hard-water-map-mockup-public.json")
    : "/assets/hard-water-map-mockup-public.json";
  var WORKER_URL = "https://filter-flair-postcode-proxy.mark-jones-5ce.workers.dev";
  var TURNSTILE_SITE_KEY = "0x4AAAAAACypIvdMm20gG8wJ";

  var form = root.querySelector("#ff-whm-search-form");
  var input = root.querySelector("#ff-whm-postcode");
  var error = root.querySelector("#ff-whm-search-error");
  var map = root.querySelector("#ff-whm-map");
  var tooltip = root.querySelector("#ff-whm-tooltip");
  var reportForm = root.querySelector("#ff-whm-report-form");
  var reportCard = root.querySelector("#ff-whm-report-card");
  var reportStatus = root.querySelector("#ff-whm-report-status");
  var resultGrid = root.querySelector("#ff-whm-result-grid");

  var els = {
    postcode: root.querySelector("#ff-whm-result-postcode"),
    ppm: root.querySelector("#ff-whm-result-ppm"),
    pill: root.querySelector("#ff-whm-result-pill"),
    band: root.querySelector("#ff-whm-result-band"),
    summary: root.querySelector("#ff-whm-result-summary"),
    company: root.querySelector("#ff-whm-result-company"),
    companyMark: root.querySelector("#ff-whm-company-mark"),
    marker: root.querySelector("#ff-whm-marker")
  };

  var cache = null;
  var currentRecord = null;
  var currentLookupPostcode = "";
  var currentLookupMethod = "";
  var turnstileWidgetId = null;
  var turnstileReady = false;
  var turnstilePendingResolve = null;
  var turnstilePendingReject = null;
  var FULL_POSTCODE_RE = /^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/;

  if (form) {
    var turnstileContainer = document.createElement("div");
    turnstileContainer.id = "ff-whm-turnstile";
    turnstileContainer.style.display = "none";
    form.appendChild(turnstileContainer);
  }

  var BAND_COLORS = {
    "soft": "#dceefa",
    "moderately-hard": "#a6ceec",
    "hard": "#6facdf",
    "very-hard": "#2f7fca"
  };

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function normalizePostcode(value) {
    return String(value || "").trim().toUpperCase().replace(/\s+/g, "");
  }

  function formatPostcode(value) {
    var compact = normalizePostcode(value);
    if (!compact) return "";
    if (compact.length <= 3) return compact;
    return compact.slice(0, -3) + " " + compact.slice(-3);
  }

  function getOutcode(value) {
    var compact = normalizePostcode(value);
    if (/^[A-Z]{1,2}[0-9][A-Z0-9]?$/.test(compact)) return compact;
    return compact.slice(0, -3);
  }

  function isFullPostcode(value) {
    return FULL_POSTCODE_RE.test(normalizePostcode(value));
  }

  function isValidPostcode(value) {
    return isFullPostcode(value);
  }

  function loadTurnstileScript() {
    window.ffWhmTurnstileReady = function () {
      turnstileReady = true;
      renderTurnstileWidget();
    };

    if (window.turnstile) {
      turnstileReady = true;
      renderTurnstileWidget();
      return;
    }

    if (document.querySelector('script[src*="turnstile"]')) return;
    var script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=ffWhmTurnstileReady";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  function renderTurnstileWidget() {
    if (!turnstileReady || !window.turnstile || turnstileWidgetId !== null) return;
    var container = root.querySelector("#ff-whm-turnstile");
    if (!container) return;

    turnstileWidgetId = window.turnstile.render(container, {
      sitekey: TURNSTILE_SITE_KEY,
      size: "normal",
      appearance: "execute",
      execution: "execute",
      "refresh-expired": "auto",
      callback: function (token) {
        if (turnstilePendingResolve) {
          var resolve = turnstilePendingResolve;
          turnstilePendingResolve = null;
          turnstilePendingReject = null;
          resolve(token);
        }
      },
      "error-callback": function () {
        if (turnstilePendingReject) {
          var reject = turnstilePendingReject;
          turnstilePendingResolve = null;
          turnstilePendingReject = null;
          reject(new Error("Security check failed. Please refresh and try again."));
        }
      }
    });
  }

  function resetTurnstile() {
    if (window.turnstile && turnstileWidgetId !== null) {
      window.turnstile.reset(turnstileWidgetId);
    }
  }

  function getTurnstileToken() {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      var timer = setInterval(function () {
        renderTurnstileWidget();
        if (window.turnstile && turnstileWidgetId !== null) {
          clearInterval(timer);
          turnstilePendingResolve = resolve;
          turnstilePendingReject = reject;
          try {
            window.turnstile.execute(turnstileWidgetId);
          } catch (error) {
            turnstilePendingResolve = null;
            turnstilePendingReject = null;
            reject(error);
          }
          return;
        }

        if (Date.now() - started > 10000) {
          clearInterval(timer);
          reject(new Error("Security check timed out. Please refresh and try again."));
        }
      }, 100);
    });
  }

  function bandForPpm(ppm) {
    var value = Number(ppm);
    if (!isFinite(value)) value = 0;

    if (value <= 100) {
      return {
        slug: "soft",
        label: "Soft water",
        shortLabel: "Soft",
        range: "0 - 100",
        summary: "Likely limescale risk: very low",
        advice: "A carbon filter is usually enough if taste or chlorine is the main concern."
      };
    }

    if (value <= 200) {
      return {
        slug: "moderately-hard",
        label: "Moderately hard water",
        shortLabel: "Moderately hard",
        range: "100 - 200",
        summary: "Likely limescale risk: moderate",
        advice: "A limescale filter can help protect kettles, shower fittings, and small appliances."
      };
    }

    if (value <= 300) {
      return {
        slug: "hard",
        label: "Hard water",
        shortLabel: "Hard",
        range: "200 - 300",
        summary: "Likely limescale risk: high",
        advice: "A whole-home scale control system is worth considering for appliances and pipework."
      };
    }

    return {
      slug: "very-hard",
      label: "Very hard water",
      shortLabel: "Very hard",
      range: "300+",
      summary: "Likely limescale risk: very high",
      advice: "Whole-house treatment gives the strongest protection for boilers, taps, showers, and appliances."
    };
  }

  function markerPercent(ppm) {
    var displayMax = 400;
    var value = Number(ppm);
    if (!isFinite(value) || value < 0) value = 0;
    return Math.max(0, Math.min(100, (value / displayMax) * 100));
  }

  function companyInitials(name) {
    if (!name || /regional estimate/i.test(name)) return "FF";
    return name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) { return part.charAt(0); })
      .join("")
      .toUpperCase();
  }

  function loadData() {
    if (cache) return Promise.resolve(cache);

    return Promise.all([
      fetch(dataUrl).then(function (res) {
        if (!res.ok) throw new Error("Could not load water hardness data.");
        return res.json();
      }),
      fetch(publicUrl).then(function (res) {
        if (!res.ok) throw new Error("Could not load postcode data.");
        return res.json();
      })
    ]).then(function (parts) {
      var data = parts[0];
      var publicMap = parts[1];
      cache = {
        areas: data.areas || {},
        publicMap: publicMap || {}
      };
      patchMapColours(cache.areas);
      return cache;
    });
  }

  function createRecordFromArea(areaCode, options) {
    options = options || {};
    var area = cache && cache.areas ? cache.areas[areaCode] : null;
    if (!area) return null;

    var ppm = typeof area.source_ppm === "number" ? area.source_ppm : Number(area.source_ppm || 0);
    var record = {
      postcode: options.postcode || area.area_name,
      outcode: options.outcode || "",
      admin_district_code: areaCode,
      area_name: area.area_name || options.areaName || "Matched area",
      source_ppm: ppm,
      water_company: area.water_company || "Water supplier data",
      supply_zone: area.supply_zone || "",
      coverage_status: area.coverage_status || "estimated"
    };

    if (/regional estimate/i.test(record.water_company) && options.publicAreaName) {
      record.water_company = "Water supply zone estimate";
    }

    return record;
  }

  function lookup(value) {
    if (isFullPostcode(value)) return lookupPostcodeWorker(value);
    return Promise.resolve(null);
  }

  function lookupPostcodeWorker(value) {
    return getTurnstileToken()
      .then(function (token) {
        resetTurnstile();
        return fetch(WORKER_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ postcode: normalizePostcode(value), token: token })
        });
      })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (response.status === 403) throw new Error("Security check failed. Please refresh the page and try again.");
          if (response.status === 429) throw new Error("Too many lookups. Please wait a few minutes and try again.");
          if (response.status === 404) throw new Error("We do not have data for this postcode area yet.");
          if (!response.ok) throw new Error(payload && payload.error ? payload.error : "Service temporarily unavailable. Please try again.");
          return payload;
        });
      })
      .then(function (payload) {
        var hardness = payload.hardness || {};
        var ppm = typeof hardness.ppm === "number" ? hardness.ppm : Number(hardness.ppm || 0);
        return {
          postcode: formatPostcode(value),
          outcode: payload.outcode || getOutcode(value),
          admin_district_code: payload.admin_district_code || "",
          area_name: payload.area_name || payload.outcode || "Matched postcode",
          source_ppm: ppm,
          water_company: payload.water_company || "Water supplier data",
          supply_zone: payload.supply_zone || "",
          coverage_status: payload.coverage_status || "measured"
        };
      });
  }

  function setError(message) {
    if (!error) return;
    if (!message) {
      error.hidden = true;
      error.textContent = "";
      return;
    }
    error.hidden = false;
    error.textContent = message;
  }

  function renderResult(record, options) {
    if (!record) return;
    if (resultGrid) resultGrid.hidden = false;
    options = options || {};
    var ppm = Math.round(Number(record.source_ppm) || 0);
    var band = bandForPpm(ppm);
    var formattedPostcode = record.postcode || record.area_name;
    currentRecord = record;
    currentLookupPostcode = options.postcode ? formatPostcode(options.postcode) : formattedPostcode;
    currentLookupMethod = options.lookupMethod || (isFullPostcode(currentLookupPostcode) ? "postcode" : "area");

    if (els.postcode) els.postcode.textContent = formattedPostcode;
    if (els.ppm) els.ppm.textContent = String(ppm);
    if (els.pill) els.pill.textContent = ppm + " ppm";
    if (els.band) els.band.textContent = band.label;
    if (els.summary) els.summary.textContent = band.summary;
    if (els.company) els.company.textContent = record.water_company || "Water supplier data";
    if (els.companyMark) els.companyMark.textContent = companyInitials(record.water_company);
    if (els.marker) els.marker.style.left = markerPercent(ppm) + "%";

    root.dataset.currentBand = band.slug;
    highlightArea(record.admin_district_code);
  }

  function clearActiveMap() {
    if (!map) return;
    map.classList.remove("has-active");
    map.querySelectorAll(".is-active").forEach(function (path) {
      path.classList.remove("is-active");
    });
  }

  function highlightArea(areaCode) {
    if (!map || !areaCode) return;
    clearActiveMap();
    map.classList.add("has-active");
    map.querySelectorAll('[data-area-code="' + cssEscape(areaCode) + '"]').forEach(function (path) {
      path.classList.add("is-active");
    });
  }

  function patchMapColours(areas) {
    if (!map || !areas) return;
    Object.keys(areas).forEach(function (areaCode) {
      var area = areas[areaCode];
      if (!area) return;
      var ppm = typeof area.source_ppm === "number" ? area.source_ppm : Number(area.source_ppm || 0);
      var band = bandForPpm(ppm);
      var fill = BAND_COLORS[band.slug];
      map.querySelectorAll('[data-area-code="' + cssEscape(areaCode) + '"]').forEach(function (path) {
        path.setAttribute("fill", fill);
        path.setAttribute("data-band", band.slug);
        path.setAttribute("data-ppm", String(ppm));
      });
    });
  }

  function showTooltip(path, event) {
    if (!tooltip || !path || !cache) return;
    var areaCode = path.getAttribute("data-area-code");
    var area = cache.areas[areaCode];
    if (!area) return;
    var ppm = typeof area.source_ppm === "number" ? area.source_ppm : Number(area.source_ppm || 0);
    var band = bandForPpm(ppm);

    tooltip.innerHTML = "<strong>" + escapeHtml(area.area_name || "Area") + "</strong>" +
      escapeHtml(ppm + " ppm - " + band.shortLabel);
    tooltip.hidden = false;

    var host = tooltip.offsetParent || root;
    var hostRect = host.getBoundingClientRect();
    var x = event.clientX - hostRect.left + 14;
    var y = event.clientY - hostRect.top + 14;
    tooltip.style.left = x + "px";
    tooltip.style.top = y + "px";
  }

  function hideTooltip() {
    if (tooltip) tooltip.hidden = true;
  }

  function bindMap() {
    if (!map) return;

    map.addEventListener("mousemove", function (event) {
      var path = event.target.closest ? event.target.closest("[data-area-code]") : null;
      if (!path || !map.contains(path)) {
        hideTooltip();
        return;
      }
      showTooltip(path, event);
    });

    map.addEventListener("mouseleave", hideTooltip);

    map.addEventListener("click", function (event) {
      var path = event.target.closest ? event.target.closest("[data-area-code]") : null;
      if (!path || !map.contains(path) || !cache) return;
      var areaCode = path.getAttribute("data-area-code");
      var record = createRecordFromArea(areaCode, { postcode: cache.areas[areaCode] ? cache.areas[areaCode].area_name : "Selected area" });
      if (record) {
        setError("");
        renderResult(record, { lookupMethod: "map" });
      }
    });
  }

  function bindForm() {
    if (!form || !input) return;
    var button = form.querySelector("button");
    var isSubmitting = false;

    function handleLookup(event) {
      if (event) event.preventDefault();
      if (isSubmitting) return;
      var value = input.value;
      if (!isValidPostcode(value)) {
        setError("Enter a full UK postcode, for example M50 2PQ.");
        return;
      }

      isSubmitting = true;
      setError("");
      if (button) {
        button.disabled = true;
        button.textContent = "Checking...";
      }
      lookup(value).then(function (record) {
        if (!record) {
          setError("We could not match that postcode to a water supply zone yet.");
          return;
        }
        renderResult(record, {
          postcode: value,
          lookupMethod: isFullPostcode(value) ? "postcode" : "outcode"
        });
      }).catch(function (error) {
        setError(error && error.message ? error.message : "Water hardness data could not be loaded. Please try again.");
      }).then(function () {
        isSubmitting = false;
        if (button) {
          button.disabled = false;
          button.textContent = "Check hardness";
        }
      });
    }

    form.addEventListener("submit", handleLookup);
    if (button) button.addEventListener("click", handleLookup);
    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") handleLookup(event);
    });
  }

  function bindReportForm() {
    if (!reportForm) return;
    reportForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var emailInput = reportForm.querySelector("input[type='email']");
      var email = emailInput ? emailInput.value.trim() : "";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (reportStatus) reportStatus.textContent = "Enter a valid email address.";
        if (emailInput) emailInput.focus();
        return;
      }

      if (!currentRecord || currentLookupMethod !== "postcode" || !isFullPostcode(currentLookupPostcode)) {
        if (reportStatus) reportStatus.textContent = "Enter a full postcode above before requesting the report.";
        if (input) input.focus();
        return;
      }

      var button = reportForm.querySelector("button");
      if (button) {
        button.disabled = true;
        button.textContent = "Sending...";
      }
      if (emailInput) emailInput.disabled = true;
      if (reportStatus) reportStatus.textContent = "Creating your report link...";

      getTurnstileToken()
        .then(function (token) {
          resetTurnstile();
          return fetch(WORKER_URL + "/klaviyo/sync", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: email,
              postcode: normalizePostcode(currentLookupPostcode),
              token: token
            })
          });
        })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok || !payload.ok) {
              throw new Error(payload && payload.error ? payload.error : "Could not create your report. Please try again.");
            }
            return payload;
          });
        })
        .then(function () {
          if (reportCard) reportCard.classList.add("is-sent");
          if (reportStatus) reportStatus.textContent = "Report created. Check your inbox for the link.";
          reportForm.querySelectorAll("input, button").forEach(function (node) {
            node.disabled = true;
          });
        })
        .catch(function (error) {
          if (reportStatus) reportStatus.textContent = error && error.message ? error.message : "Could not create your report. Please try again.";
          if (button) {
            button.disabled = false;
            button.textContent = "Send my report";
          }
          if (emailInput) emailInput.disabled = false;
        });
    });
  }

  loadTurnstileScript();
  bindForm();
  bindReportForm();
  bindMap();

  loadData().catch(function () {
    setError("Water hardness data could not be loaded. Please try again.");
  });
})();
